import React, { useState, useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { View, Text, Pressable, StyleSheet, ScrollView, Icon2 } from '../lib/react-native-compat';
import ProductivityCombined from './productivityCombined';
import Scorecard from './scorecard';
import { userIdAtom } from '../store/company';

const ProductivityDashboard = () => {
    const [activeTab, setActiveTab] = useState('Productivity Tracker');
    const tabs = ['Productivity Tracker', 'Scorecard'];
    const [collapsed, setCollapsed] = useState(false);
    const productivityRef = useRef(null);
    const scorecardRef = useRef(null);
    const [userId] = useAtom(userIdAtom);

    const handleExportExcel = () => {
        if (productivityRef.current?.createExcel) {
            productivityRef.current.createExcel();
        }
        if (scorecardRef.current?.createExcel) {
            scorecardRef.current.createExcel();
        }
    };

    return (
        <View>
            <View style={styles.container}>
                <View style={{ flexDirection: 'row', gap: 20, marginLeft: 10 }}>
                    {tabs.map((tab) => (
                        <Pressable
                            key={tab}
                            onPress={() => setActiveTab(tab)}
                            style={[
                                styles.tabItem,
                                {
                                    paddingVertical: 12,
                                    paddingHorizontal: 16,
                                    borderBottom: activeTab === tab ? '2px solid #2563eb' : '2px solid transparent',
                                    justifyContent: 'center',
                                }
                            ]}
                        >
                            <Text style={[styles.tabText, activeTab === tab && styles.activeText]}>
                                {tab}
                            </Text>
                        </Pressable>
                    ))}
                </View>
                <View style={{ flexDirection: 'row', padding: 5 }}>
                    {/* <Pressable
                        style={{
                            alignItems: 'center',
                            borderColor: '#cfd3d5',
                            borderWidth: 1,
                            borderRadius: 8,
                            justifyContent: 'center',
                            paddingVertical: 12,
                            paddingHorizontal: 8,
                        }}
                        onPress={() => {
                            createExcel()
                        }}
                    >
                        <Icon2
                            name="file-download"
                            size={20}
                        />
                    </Pressable> */}
                    <Pressable
                        style={{ 
                            alignItems: 'center', 
                            backgroundColor: '#f8fafc', 
                            padding: 12,
                            paddingHorizontal: 16, 
                            borderRadius: 6, 
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 20
                        }}
                        onPress={() => {
                            setCollapsed(!collapsed)
                        }}
                    >
                        <Text style={{ color: '#334155', fontWeight: '500', fontSize: 14 }}>Collapse/Expand</Text>
                    </Pressable>
                    <Pressable
                        style={{ 
                            alignItems: 'center', 
                            backgroundColor: '#f8fafc', 
                            padding: 12,
                            paddingHorizontal: 16, 
                            borderRadius: 6, 
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 20
                        }}
                        onPress={handleExportExcel}
                    >
                        <Text style={{ color: '#334155', fontWeight: '500', fontSize: 14 }}>Export Excel</Text>
                    </Pressable>
                    {userId === '154045' && (
                        <Pressable
                            style={{
                                alignItems: 'center',
                                backgroundColor: '#eff6ff',
                                padding: 12,
                                paddingHorizontal: 16,
                                borderRadius: 6,
                                flexDirection: 'row',
                                border: '1px solid #93c5fd',
                                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                                marginLeft: 10
                            }}
                            onPress={() => {
                                if (productivityRef.current?.savePFData) {
                                    productivityRef.current.savePFData();
                                }
                            }}
                        >
                            <Text style={{ color: '#1d4ed8', fontWeight: '500', fontSize: 14 }}>Save PF</Text>
                        </Pressable>
                    )}
                </View>
            </View>
            {activeTab === 'Productivity Tracker' ? <ProductivityCombined ref={productivityRef} collapsedParent={collapsed} /> : <Scorecard ref={scorecardRef} />}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        paddingLeft: 20,
        paddingTop: 8,
        borderBottom: '1px solid #e2e8f0',
        flexDirection: 'row',
    },
    tabItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
    },
    activeTab: {
        borderBottomColor: '#2563eb',
    },
    tabText: {
        fontSize: 14,
        color: '#6b7280',
        fontWeight: '400',
    },
    activeText: {
        color: '#2563eb',
        fontWeight: '500',
    },
    content: {
        padding: 20,
    },
    contentText: {
        fontSize: 16,
    },
});

export default ProductivityDashboard;

